import chroma from 'chroma-js';

import type { GradientLegendEntry } from '../gradient-legend/gradient-legend';

export type ChoroplethColorStops = {
  min: number;
  max: number;
  colors: string[];
};

const DEFAULT_COLORS = ['#f7fbff', '#c6dbef', '#6baed6', '#2171b5', '#08306b'];
const EMPTY_FILL = '#e9ecef';

export function computeChoroplethStops(values: number[]): ChoroplethColorStops {
  const positive = values.filter((value) => value > 0);
  if (positive.length === 0) {
    return { min: 0, max: 1, colors: DEFAULT_COLORS };
  }
  return {
    min: Math.min(...positive),
    max: Math.max(...positive),
    colors: DEFAULT_COLORS,
  };
}

export function buildGradientLegend(
  stops: ChoroplethColorStops,
  formatValue: (value: number) => string,
): GradientLegendEntry[] {
  const { min, max, colors } = stops;
  if (min === max) {
    return [
      {
        value: min,
        label: formatValue(min),
        color: colors[colors.length - 1],
      },
    ];
  }

  return colors.map((color, index) => {
    const value = min + ((max - min) * index) / (colors.length - 1);
    return {
      value,
      label: formatValue(value),
      color,
    };
  });
}

export function getChoroplethFillColor(
  value: number,
  stops: ChoroplethColorStops,
  emptyColor = EMPTY_FILL,
): string {
  if (!value || value <= 0) {
    return emptyColor;
  }

  const { min, max, colors } = stops;
  if (min === max) {
    return colors[colors.length - 1];
  }

  return chroma.scale(colors).domain([min, max])(value).hex();
}
